import React, { useState } from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import repositoryContainer from '../../../services/RepositoryContainer';


const BookingFilters = ({ 
  filters, 
  onFilterChange, 
  onSearch, 
  onReset,
  onExport 
}) => {

   const getServiceOptions = async () => {
      try {
        const services = await repositoryContainer.service.list({ type: 'service'}) || [];
        return [
          { value: 'all', label: 'All Services' },
          ...services.map(service => ({ value: service?.id, label: service?.name }))
        ];
      }catch (error) {
        console.error('Failed to load services:', error);
        return [
          { value: 'all', label: 'All Services' }
        ];
      }
    };
  
    const [serviceOptions, setServiceOptions] = useState([]);
    React.useEffect(() => {
      const loadServices = async () => {
        const options = await getServiceOptions();
        setServiceOptions(options);
      };
      loadServices(); 
    }, []);

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'pending', label: 'Pending' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' }
  ];

  const dateRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'upcoming', label: 'Upcoming' },
    { value: 'past', label: 'Past' },
    { value: 'this_week', label: 'This Week' },
    { value: 'this_month', label: 'This Month' },
    { value: 'custom', label: 'Custom Range' }
  ];

  // const serviceOptions = [
  //   { value: 'all', label: 'All Services' },
  //   { value: 'manicure', label: 'Manicure' },
  //   { value: 'pedicure', label: 'Pedicure' },
  //   { value: 'gel_nails', label: 'Gel Nails' },
  //   { value: 'acrylic_nails', label: 'Acrylic Nails' },
  //   { value: 'nail_art', label: 'Nail Art' }
  // ];

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Input
            type="search"
            placeholder="Search by name, phone, or email..."
            value={filters?.searchQuery}
            onChange={(e) => onSearch(e?.target?.value)}
            className="lg:col-span-2"
          />

          <Select
            placeholder="Filter by status"
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => onFilterChange('status', value)}
          />

          <Select
            placeholder="Date range"
            options={dateRangeOptions}
            value={filters?.dateRange}
            onChange={(value) => onFilterChange('dateRange', value)}
          />

          <Select
            placeholder="Service type"
            options={serviceOptions}
            value={filters?.service}
            onChange={(value) => onFilterChange('service', value)}
            className="md:col-span-2 lg:col-span-1"
          />

          {filters?.dateRange === 'custom' && (
            <>
              <Input
                type="date"
                label="Start Date"
                value={filters?.startDate}
                onChange={(e) => onFilterChange('startDate', e?.target?.value)}
              />
              <Input
                type="date"
                label="End Date"
                value={filters?.endDate}
                onChange={(e) => onFilterChange('endDate', e?.target?.value)}
              />
            </>
          )}
        </div>

        <div className="flex gap-2">
          <Button
            variant="outline"
            iconName="RotateCcw"
            onClick={onReset}
            className="flex-1 lg:flex-none"
          >
            Reset
          </Button>
          <Button
            variant="secondary"
            iconName="Download"
            onClick={onExport}
            className="flex-1 lg:flex-none"
          >
            Export
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BookingFilters;